/*
  Article FAQ accordion enhancer.

  Finds the LAST <h2> in .article__content whose text matches an
  FAQ-style heading and converts the following <h3>+<p>... pairs into
  collapsible <details> blocks.

  Defensive:
  - Renders nothing if no matching <h2> is found.
  - Renders nothing if no <h3>s appear before the next <h2>.
  - Skips when the FAQs region already contains <details> markup
    (so re-running on the same DOM is a no-op).
*/

(() => {
  if (window.__articleFaqEnhancerInit) return;
  window.__articleFaqEnhancerInit = true;

  const FAQ_HEADINGS = ['faqs', 'faq', 'frequently asked questions'];

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function findFaqsHeading(root) {
    const h2s = Array.from(root.querySelectorAll('h2'));
    for (let i = h2s.length - 1; i >= 0; i--) {
      const text = (h2s[i].textContent || '').trim().toLowerCase().replace(/[^a-z\s]/g, '');
      if (FAQ_HEADINGS.includes(text)) return h2s[i];
    }
    return null;
  }

  function enhance() {
    const root = document.querySelector('.article__content');
    if (!root) return;
    const heading = findFaqsHeading(root);
    if (!heading) return;
    if (heading.parentElement.querySelector(':scope > details.article-faq__item')) return;

    // Walk siblings until next h2 or end of root content.
    const items = [];
    let cur = heading.nextElementSibling;
    let currentItem = null;

    while (cur && cur.tagName !== 'H2') {
      if (cur.tagName === 'H3') {
        if (currentItem) items.push(currentItem);
        currentItem = { question: cur, answers: [] };
      } else if (currentItem) {
        currentItem.answers.push(cur);
      }
      cur = cur.nextElementSibling;
    }
    if (currentItem) items.push(currentItem);

    if (!items.length) return;

    // Wrap each pair in a <details> block. Replace the original elements.
    const wrapper = document.createElement('div');
    wrapper.className = 'article-faq';

    items.forEach((item, idx) => {
      const details = document.createElement('details');
      details.className = 'article-faq__item';
      // First item open by default for visual richness; rest closed.
      if (idx === 0) details.open = true;

      const summary = document.createElement('summary');
      summary.className = 'article-faq__summary';
      const summaryText = document.createElement('span');
      summaryText.className = 'article-faq__question';
      summaryText.textContent = item.question.textContent.trim();
      const summaryIcon = document.createElement('span');
      summaryIcon.className = 'article-faq__icon';
      summaryIcon.setAttribute('aria-hidden', 'true');
      summaryIcon.innerHTML = '<svg width="14" height="14" viewBox="0 0 20 20" fill="none"><path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      summary.appendChild(summaryText);
      summary.appendChild(summaryIcon);
      details.appendChild(summary);

      const body = document.createElement('div');
      body.className = 'article-faq__answer';
      item.answers.forEach((node) => body.appendChild(node.cloneNode(true)));
      details.appendChild(body);

      wrapper.appendChild(details);

      // Remove originals
      item.question.remove();
      item.answers.forEach((node) => node.remove());
    });

    heading.insertAdjacentElement('afterend', wrapper);
  }

  ready(enhance);
})();
